export const CardsFlip = () => {

  function flipCards () {
    for (const frontOrBack of document.querySelectorAll('.m-cards__card-inner > .m-cards__card')) {
      frontOrBack.addEventListener('click', () => {
        frontOrBack.parentElement.classList.toggle('flipped');
      });
    }
  }

  function setHeightOfLargestCard() {

    let allHeights = [];

    for (const frontOrBack of document.querySelectorAll('.m-cards__card-inner > .m-cards__card > .m-cards__card-wrap')) {

      console.log(frontOrBack, frontOrBack.offsetHeight)

      allHeights.push(frontOrBack.offsetHeight)
    }

    let heightOfLargestCard = Math.max(...allHeights);

    console.log(allHeights)

    for (const frontOrBack of document.querySelectorAll('.m-cards__card-inner > .m-cards__card > .m-cards__card-wrap')) {
      frontOrBack.parentElement.parentElement.style.minHeight = `${heightOfLargestCard + 40}px`;
    }
  }

  flipCards();
  setHeightOfLargestCard();

  window.addEventListener('resize', function(event) {
   setHeightOfLargestCard();
  }, true);
}

export default CardsFlip
